export default __webpack_public_path__ + "static/media/intelligent-matching-icon.0c70d563.svg";